import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PostPayloadComponent } from './post-payload/post-payload.component';

import { ValidationComponent } from './validation.component';

const routes: Routes = [
  {
    path: '',
    component: ValidationComponent,
    data: { title: 'Validation' },
  },
  {
    path: 'post',
    component: PostPayloadComponent,
    pathMatch: 'full',
    data: { title: 'Validate Payload' },
  },
  {
    path: ':id',
    component: ValidationComponent,
    data: { title: 'Validation' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ValidationRoutingModule {}
